import { FaTrophy, FaUserFriends, FaStar } from 'react-icons/fa';
import { motion } from 'framer-motion';
import './SocialProof.css';

const CARDS = [
  {
    icon: <FaTrophy />,
    iconBg: 'linear-gradient(135deg, #1e40af, #2563eb)',
    stat: 'Best Legal Tech 2024',
    desc: 'Award-winning passenger rights platform trusted by thousands globally.',
    tag: 'Industry Leader',
    tagColor: '#1e40af',
    tagBg: '#eff6ff',
  },
  {
    icon: <FaUserFriends />,
    iconBg: 'linear-gradient(135deg, #16a34a, #22c55e)',
    stat: '2 Million+ Helped',
    desc: 'Passengers successfully compensated across 20+ countries worldwide.',
    tag: '5+ Years',
    tagColor: '#16a34a',
    tagBg: '#f0fdf4',
  },
  {
    icon: <FaStar />,
    iconBg: 'linear-gradient(135deg, #1e40af, #16a34a)',
    stat: '4.4 Trustpilot',
    desc: 'Rated Excellent by over 35,000 verified passengers. 98% success rate.',
    tag: 'Excellent',
    tagColor: '#16a34a',
    tagBg: '#f0fdf4',
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 36 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.55, ease: 'easeOut' } },
};
const stagger = {
  hidden: {},
  show:   { transition: { staggerChildren: 0.15 } },
};

export default function SocialProof() {
  return (
    <section className="sp">
      <div className="sp__inner">
        <motion.div
          className="sp__header"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.55, ease: 'easeOut' }}
        >
          <h2 className="sp__title">
            AirRefund is <span>number&nbsp;1</span> worldwide
          </h2>
        </motion.div>

        <motion.div
          className="sp__grid"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
          variants={stagger}
        >
          {CARDS.map(({ icon, iconBg, stat, desc, tag, tagColor, tagBg }) => (
            <motion.div
              key={stat}
              className="sp__card"
              variants={fadeUp}
              whileHover={{ y: -6, boxShadow: '0 20px 48px rgba(10,22,40,0.12)' }}
              transition={{ duration: 0.22 }}
            >
              <div className="sp__icon-wrap" style={{ background: iconBg }}>
                {icon}
              </div>

              <span className="sp__tag" style={{ color: tagColor, background: tagBg }}>
                {tag}
              </span>

              <h3 className="sp__stat">{stat}</h3>
              <p className="sp__desc">{desc}</p>

              <div className="sp__bar" style={{ background: iconBg }} />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}